import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "customer-intelligence",
  "use": "customer-intelligence-usage",
  "viewBox": "0 0 16 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 20\" id=\"customer-intelligence\"><path d=\"M11.461 15.833c.263-1.576.926-3.066 1.894-4.366A6.62 6.62 0 0014.667 7.5 6.668 6.668 0 007.24.876C4.308 1.2 1.87 3.518 1.417 6.432a6.654 6.654 0 001.185 4.974c.968 1.33 1.658 2.832 1.933 4.427m6.926 0a9.05 9.05 0 00-.127 1.498v.169c0 .92-.747 1.667-1.667 1.667H6.334c-.92 0-1.667-.746-1.667-1.667v-.166c0-.508-.048-1.008-.132-1.5m6.926 0H4.535\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/customer-intelligence.svg
// module id = 8Lc2
// module chunks = 38 43